// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { type RouteRecordRaw } from 'vue-router'

/**
 * Backward compatibility redirects
 * These redirect old route paths to their new locations in the nested route structure
 */
export const redirectRoutes: RouteRecordRaw[] = [
    // ==================== HOME ====================
    {
        path: '/router/home',
        redirect: { name: 'home' },
    },

    // ==================== USER ====================
    {
        path: '/router/user/profile',
        redirect: { name: 'user.profile' },
    },

    // ==================== COMPANY ====================
    // Analytics mode
    {
        path: '/router/company/overview/:reporting_year',
        redirect: to => ({ name: 'company.overview', params: { reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/company/assets/:reporting_year',
        redirect: to => ({ name: 'company.assets', params: { reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/company/:company_id/analytics/:reporting_year',
        redirect: to => ({ name: 'company.analytics', params: { reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/company/:company_id/esg-data/:reporting_year',
        redirect: to => ({ name: 'company.analytics', params: { reporting_year: to.params.reporting_year } }),
    },
    // Collection mode
    {
        path: '/router/company/collection/overview/:reporting_year',
        redirect: to => ({ name: 'company.collection.overview', params: { reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/company/performance/:reporting_year',
        redirect: to => ({ name: 'company.performance', params: { reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/company/performance/:reporting_year/edit/emissions',
        redirect: to => ({ name: 'company.performance.edit.emissions', params: { reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/company/performance/:reporting_year/edit/energy',
        redirect: to => ({ name: 'company.performance.edit.energy', params: { reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/company/reports/:reporting_year',
        redirect: to => ({ name: 'company.reports', params: { reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/company/settings',
        redirect: { name: 'company.settings' },
    },
    {
        path: '/router/company/users/create',
        redirect: { name: 'company.users.create' },
    },
    {
        path: '/router/company/users/bulk-create',
        redirect: { name: 'company.users.bulk-create' },
    },
    {
        path: '/router/company/users/:user_id/edit',
        redirect: to => ({ name: 'company.users.edit', params: { user_id: to.params.user_id } }),
    },

    // ==================== PORTFOLIO ====================
    // Analytics mode
    {
        path: '/router/portfolio/:portfolio_id/overview/:reporting_year',
        redirect: to => ({ name: 'portfolio.overview', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/map',
        redirect: to => ({ name: 'portfolio.map', params: { portfolio_id: to.params.portfolio_id, reporting_year: new Date().getFullYear() - 1 } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/esg-data/:reporting_year',
        redirect: to => ({ name: 'portfolio.esg-data', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/roadmap/:reporting_year',
        redirect: to => ({ name: 'portfolio.roadmap', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/measure/:measure_id',
        redirect: to => ({ name: 'portfolio.measure', params: { portfolio_id: to.params.portfolio_id, measure_id: to.params.measure_id, reporting_year: new Date().getFullYear() - 1 } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/acquisition/:acquisition_id',
        redirect: to => ({ name: 'portfolio.acquisition', params: { portfolio_id: to.params.portfolio_id, acquisition_id: to.params.acquisition_id, reporting_year: new Date().getFullYear() - 1 } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/regulatory/:reporting_year',
        redirect: to => ({ name: 'portfolio.regulatory', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/gresb-data/:reporting_year',
        redirect: to => ({ name: 'portfolio.gresb-data', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/metrics/:reporting_year',
        redirect: to => ({ name: 'portfolio.metrics', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/physical-climate/:reporting_year',
        redirect: to => ({ name: 'portfolio.physical-climate', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/dashboards/:reporting_year',
        redirect: to => ({ name: 'portfolio.custom-dashboard.list', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/dashboards/:reporting_year/:dashboard_id',
        redirect: to => ({ name: 'portfolio.custom-dashboard.view', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year, dashboard_id: to.params.dashboard_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/dashboards/:reporting_year/:dashboard_id/edit',
        redirect: to => ({ name: 'portfolio.custom-dashboard.edit', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year, dashboard_id: to.params.dashboard_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/dashboards/:reporting_year/create',
        redirect: to => ({ name: 'portfolio.custom-dashboard.create', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    // Collection mode
    {
        path: '/router/portfolio/:portfolio_id/input-overview/:reporting_year',
        redirect: to => ({ name: 'portfolio.input-overview', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset-list/collection/:reporting_year',
        redirect: to => ({ name: 'portfolio-asset.collection.list', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/meter-completion-list/:reporting_year',
        redirect: to => ({ name: 'portfolio-asset.meter-completion-list', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/roadmap-data-collection/:reporting_year',
        redirect: to => ({ name: 'portfolio.roadmap-data-collection', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/measure-data-collection/:measure_id?',
        redirect: to => ({ name: 'portfolio.measure-data-collection', params: { portfolio_id: to.params.portfolio_id, measure_id: to.params.measure_id || '' } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/acquisition-data-collection/:acquisition_id?',
        redirect: to => ({ name: 'portfolio.acquisition-data-collection', params: { portfolio_id: to.params.portfolio_id, acquisition_id: to.params.acquisition_id || '' } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/governance',
        redirect: to => ({ name: 'portfolio.governance', params: { portfolio_id: to.params.portfolio_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/data-request',
        redirect: to => ({ name: 'portfolio.data-request', params: { portfolio_id: to.params.portfolio_id, reporting_year: new Date().getFullYear() - 1 }, query: to.query }),
    },
    {
        path: '/router/portfolio/:portfolio_id/:reporting_year/data-request',
        redirect: to => ({ name: 'portfolio.data-request', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year }, query: to.query }),
    },
    {
        path: '/router/portfolio/:portfolio_id/report-overview/:reporting_year',
        redirect: to => ({ name: 'portfolio.reports-overview', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/target/:reporting_year',
        redirect: to => ({ name: 'portfolio.custom-roadmap-targets-and-benchmarks', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/settings',
        redirect: to => ({ name: 'portfolio.settings', params: { portfolio_id: to.params.portfolio_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/emission-factors',
        redirect: to => ({ name: 'portfolio.emission-factors', params: { portfolio_id: to.params.portfolio_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/surveys',
        redirect: to => ({ name: 'portfolio.surveys', params: { portfolio_id: to.params.portfolio_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/surveys/view/:survey_id',
        redirect: to => ({ name: 'portfolio.survey.regular.view', params: { portfolio_id: to.params.portfolio_id, survey_id: to.params.survey_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/surveys/review/:survey_id',
        redirect: to => ({ name: 'portfolio.survey.regular.review', params: { portfolio_id: to.params.portfolio_id, survey_id: to.params.survey_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/surveys/edit/:survey_id',
        redirect: to => ({ name: 'portfolio.survey.regular.edit', params: { portfolio_id: to.params.portfolio_id, survey_id: to.params.survey_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/surveys/new',
        redirect: to => ({ name: 'portfolio.survey.regular.new', params: { portfolio_id: to.params.portfolio_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/surveys/meters/review/:survey_id',
        redirect: to => ({ name: 'portfolio.survey.meters.review', params: { portfolio_id: to.params.portfolio_id, survey_id: to.params.survey_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/surveys/meters/view/:survey_id',
        redirect: to => ({ name: 'portfolio.survey.meters.view', params: { portfolio_id: to.params.portfolio_id, survey_id: to.params.survey_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/surveys/meters/edit/:survey_id',
        redirect: to => ({ name: 'portfolio.survey.meters.edit', params: { portfolio_id: to.params.portfolio_id, survey_id: to.params.survey_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/surveys/meters/new',
        redirect: to => ({ name: 'portfolio.survey.meters.new', params: { portfolio_id: to.params.portfolio_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/annual-report/:reporting_year',
        redirect: to => ({ name: 'portfolio.saved-reports', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/physical-climate-measures',
        redirect: to => ({ name: 'portfolio.physical-climate-measures', params: { portfolio_id: to.params.portfolio_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/physical-climate-measures/:measure_id',
        redirect: to => ({ name: 'portfolio.physical-climate-measure', params: { portfolio_id: to.params.portfolio_id, measure_id: to.params.measure_id } }),
    },
    // Portfolio-asset routes
    {
        path: '/router/portfolio/:portfolio_id/asset/list/:reporting_year',
        redirect: to => ({ name: 'portfolio-asset.list', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/automations',
        redirect: to => ({ name: 'portfolio-asset.automations', params: { portfolio_id: to.params.portfolio_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/meters-overview/:reporting_year',
        redirect: to => ({ name: 'portfolio-asset.meters-overview', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/consumption-coverage/:reporting_year',
        redirect: to => ({ name: 'portfolio-asset.consumption-coverage', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/asset-details-list/:reporting_year',
        redirect: to => ({ name: 'portfolio-asset.asset-details-list', params: { portfolio_id: to.params.portfolio_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/bill-scraping-log',
        redirect: to => ({ name: 'portfolio-asset.bill-scraping-log', params: { portfolio_id: to.params.portfolio_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/asset-mappings',
        redirect: to => ({ name: 'portfolio-asset.asset-mappings-list', params: { portfolio_id: to.params.portfolio_id } }),
    },

    // ==================== ASSET ====================
    // Analytics mode
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/overview/:reporting_year',
        redirect: to => ({ name: 'asset.overview', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/details/:reporting_year',
        redirect: to => ({ name: 'asset.details', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/esg-data/:reporting_year',
        redirect: to => ({ name: 'asset.analytics', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/meter-analytics/:reporting_year',
        redirect: to => ({ name: 'asset.meter-analytics', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/metrics/:reporting_year',
        redirect: to => ({ name: 'asset.metrics', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/scores/:reporting_year',
        redirect: to => ({ name: 'asset.scores', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/roadmap/:reporting_year',
        redirect: to => ({ name: 'asset.roadmap', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/building-units/:reporting_year',
        redirect: to => ({ name: 'asset.building-units', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    // Collection mode (Input Portal)
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/input-portal/:reporting_year/asset-characteristics',
        redirect: to => ({ name: 'asset.input-portal.asset-characteristics', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/input-portal/:reporting_year/reporting-data',
        redirect: to => ({ name: 'asset.input-portal.reporting-data', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/input-portal/:reporting_year/certifications',
        redirect: to => ({ name: 'asset.input-portal.certifications', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/input-portal/:reporting_year/meters-and-consumptions',
        redirect: to => ({ name: 'asset.input-portal.meters-and-consumptions', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/input-portal/:reporting_year/assessments-and-measures',
        redirect: to => ({ name: 'asset.input-portal.assessments-and-measures', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/input-portal/:reporting_year/roadmap',
        redirect: to => ({ name: 'asset.input-portal.roadmap', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/input-portal/:reporting_year/physical-climate',
        redirect: to => ({ name: 'asset.input-portal.physical-climate', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/input-portal/:reporting_year/social-data',
        redirect: to => ({ name: 'asset.input-portal.social-data', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/input-portal/:reporting_year/financial-data',
        redirect: to => ({ name: 'asset.input-portal.financial-data', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/input-portal/:reporting_year/building-units',
        redirect: to => ({ name: 'asset.input-portal.building-units', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/input-portal/:reporting_year/development',
        redirect: to => ({ name: 'asset.input-portal.development', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/input-portal/:reporting_year/document-library',
        redirect: to => ({ name: 'asset.input-portal.document-library', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/input-portal/:reporting_year/automations',
        redirect: to => ({ name: 'asset.input-portal.automations', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/input-portal/:reporting_year/custom-fields',
        redirect: to => ({ name: 'asset.input-portal.custom-fields', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, reporting_year: to.params.reporting_year } }),
    },

    // ==================== ASSET GROUP ====================
    {
        path: '/router/portfolio/:portfolio_id/asset-group/:asset_group_id/characteristics',
        redirect: to => ({ name: 'asset-group.group-characteristics', params: { portfolio_id: to.params.portfolio_id, asset_group_id: to.params.asset_group_id } }),
    },
    {
        path: '/router/portfolio/:portfolio_id/asset-group/:asset_group_id/assets',
        redirect: to => ({ name: 'asset-group.asset-list', params: { portfolio_id: to.params.portfolio_id, asset_group_id: to.params.asset_group_id } }),
    },

    // ==================== BUILDING UNIT ====================
    {
        path: '/router/portfolio/:portfolio_id/asset/:asset_id/building-unit/:building_unit_id/:reporting_year/overview',
        redirect: to => ({ name: 'asset-building-unit.overview', params: { portfolio_id: to.params.portfolio_id, asset_id: to.params.asset_id, building_unit_id: to.params.building_unit_id, reporting_year: to.params.reporting_year } }),
    },
]
